<template>
  <div>
    <slot></slot>
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <label>&nbsp;</label>
          <button
            id="button-xlsx-report"
            class="btn btn-primary btn-modal"
            target-modal="download-progress-modal"
            @click="onGenerateReportClick()"
            :disabled="disabled"
          >{{ buttonText }}</button>
        </div>
      </div>
    </div>

    <modal-component v-model="showModal" :title="modalTitle" :preventClose="!canCloseModal">
      <div class="modal-content">
        <div class="in-progress" v-if="status === 2">
          <h2>Estamos gerando seu relatório.</h2>
          <p>A geração do relatório está em andamento e poderá levar alguns minutos. Agradecemos pela compreensão.</p>
          <img src="/images/ui/spinner.gif" alt="Carregando" />
        </div>
        <div class="success" v-if="status === 1">
          <img src="/images/ui/success.png" alt="Finalizado" />
          <h2>Finalizado!</h2>
          <h3>Terminamos de gerar o relatório, o download deve ter começado automaticamente.</h3>
          <p v-if="!fileDownloaded">
            Caso o download não tenha iniciado, clique
            <a
              :href="downloadFileURL"
              target="_blank"
            >aqui</a>.
          </p>
        </div>
        <div class="error" v-if="status === 3">
          <img src="/images/ui/cancel.png" alt="Erro" />
          <h2>Erro!</h2>
          <h3>Ocorreu um erro interno ao tentar gerar seu relatório. Tente novamente.</h3>
        </div>
      </div>
    </modal-component>
  </div>
</template>

<script>
export default {
  props: {
    module: {
      required: true,
    },
    controller: {
      required: true,
    },
    modalTitle: {
      required: true,
    },
    buttonText: {
      required: false,
      default: "Gerar Relatório",
    },
    disabled: {
      required: false,
      default: false,
    },
    params: {
      required: false,
      default: [],
    },
    paramsRequired: {
      required: false,
      default: [],
    },
    maxDays: {
      required: false,
      default: 0,
    },
  },
  data() {
    return {
      status: 2,
      downloadFileURL: "#",
      fileDownloaded: false,
      showModal: false,
      canCloseModal: false,
    };
  },
  methods: {
    resetState() {
      this.status = 2;
      this.downloadFileURL = "#";
      this.fileDownloaded = false;
      this.showModal = false;
      this.canCloseModal = false;
    },
    checkParams(params, filters) {
      let lengthTotalParams = 0;
      for(let param of params){
        lengthTotalParams += filters[param].length;
      }
      return lengthTotalParams !== 0;
    },

    checkParamsRequired(params, filters) {
      let hasNullable = false;
      for(let param of params){
        if(
          filters[param] === 0 ||
          filters[param] === '0' ||
          filters[param] === ''
        ){
          this.$toast.error(`Preencha o filtro ${param}!`);
          hasNullable = true;
        }
      }
      return hasNullable;
    },
    onGenerateReportClick() {
      const filtersFormData = new FormData();
      let hasError = false;
      const filters = {};
      this.$el.querySelectorAll("input").forEach((input) => {
        input.removeAttribute("style");
        const value =
          input.getAttribute("type") === "checkbox"
            ? input.checked
            : input.value;
        filtersFormData.set(input.getAttribute("name"), value);
        filters[input.name] = value;
        if (input.getAttribute("required") && value === "") {
          hasError = true;
          input.classList.add("shake-it");
          input.style.border = "1px solid red";
        }
      });

      if(this.params.length > 0) {
        // Caso seja obrigatório pelo menos um filtro preenchido
        let validateAtLeastOneFilter = this.checkParams(this.params, filters);
        if(!validateAtLeastOneFilter){
          this.$toast.error("Preencha pelo menos um filtro!");
          return;
        }
      }

      if(this.paramsRequired.length > 0) {
        // Caso seja obrigatório algum filtro
        let paramRequired = this.checkParamsRequired(this.paramsRequired, filters);
        if(paramRequired){
          this.resetState();
          hasError = true;
        }
      }

      // Validation
      if (hasError) {
        this.$toast.error("Preencha todos os campos obrigatórios");
        return;
      } else if (
        filters.data_inicial &&
        filters.data_final &&
        moment(filters.data_inicial, "DD/MM/YYYY") >
          moment(filters.data_final, "DD/MM/YYYY")
      ) {
        this.$toast.error(
          "A data final do período não pode ser menor que a data inicial."
        );
        return;
      }

      let dataInicial = new Date(filters.data_inicial.split('/')[2],filters.data_inicial.split('/')[1]-1,filters.data_inicial.split('/')[0]);
      let dataFinal = new Date(filters.data_final.split('/')[2],filters.data_final.split('/')[1]-1,filters.data_final.split('/')[0]);
      let diffDays = (dataFinal.getTime() - dataInicial.getTime()) / (1000 * 60 * 60 * 24);
      let filterEstabelecimento = document.getElementsByName('estabelecimento')[0].value;

      if(filterEstabelecimento === 0 || filterEstabelecimento === '0'){
        if(diffDays > 31) {
          this.$toast.error(
            `O período máximo é de 31 dias caso não esteja selecionado um estabelecimento específico.`
          );
          this.resetState();

          return;
        }
      }

      if(this.maxDays > 0){
        if(diffDays > this.maxDays){
          this.$toast.error(
            `O Período solicitado é maior que ${this.maxDays} dias.`
          );

          this.resetState();

          return;
        }
      }

      this.resetState();
      this.showModal = true;

      axios
        .post(
          `/${this.module}/${this.controller}/start-generate-report`,
          filtersFormData
        )
        .then((response) => {
          setTimeout(() => {
            this.makeXLSXFile(response.data.filename);
          }, 8000);
        })
        .catch((error) => {
          this.status = 3;
          this.canCloseModal = true;
        });
    },
    makeXLSXFile(filename) {
      const filters = new FormData();
      filters.set("filename", filename);

      axios
        .post(`/${this.module}/${this.controller}/gera-relatorio`, filters)
        .then((response) => {
          const { status } = response.data;
          this.status = status;
          if (status === 2) {
            // In progress
            setTimeout(() => {
              this.makeXLSXFile(filename);
            }, 8000);
          } else if (status === 3) {
            // Error
            this.canCloseModal = true;
          } else if (status === 1) {
            // finish
            const downloadUrl = `/${this.module}/${this.controller}/download-report/filename/${filename}`;
            window.open(downloadUrl, "_blank");
            this.downloadFileURL = downloadUrl;
            this.canCloseModal = true;
            this.checkFileExists(filename);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    checkFileExists(filename) {
      const filters = new FormData();
      filters.set("filename", filename);

      axios
        .post(`/${this.module}/${this.controller}/check-file`, filters)
        .then((response) => {
          setTimeout(() => {
            this.checkFileExists(filename);
          }, 1000);
        })
        .catch((error) => {
          this.fileDownloaded = true;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .sida-modal {
  max-width: 500px;
  .modal-content {
    height: auto;
  }
}
.download-progress-modal {
  width: 500px;
  .modal-content {
    height: auto;
    text-align: center;

    img {
      width: 80px;
    }
  }
}
</style>
